module.exports = __webpack_public_path__ + "assets/img/title-924fa3e6.png";